import { useContext } from "react";
import { AppContext } from "../../AppContext";
import { Button } from "../Common/Button";
import { Link } from "../Common/Link";
import Spacer from "../Common/Spacer";

const LogInButton = () => {
  const appCtx = useContext(AppContext);
  const { user, signIn, signOut, isMobileView } = appCtx;

  return (
    <>
      {user === null ? (
        <Button variant="primary" size={isMobileView ? "sm" : "md"} onClick={signIn}>
          Sign In
        </Button>
      ) : (
        <>
          {/* <Link hideMarkIfVisited href="/notes">
            Notes
          </Link>*/}
          {user.email === "behappy54321@gmail.com" && (
            <Link hideMarkIfVisited href="/kiali">
              Kiali
            </Link>
          )}
          <Link hideMarkIfVisited href="/note-nest">
            Note Nest
          </Link>
          {/* <Link hideMarkIfVisited href="/game/lobby/client">
            Game
          </Link> */}
          <Spacer pl={".5rem"} display="inline">
            <Button variant="secondary" outlined size={isMobileView ? "sm" : "md"} onClick={signOut}>
              {/* Sign Out ({user.email}) */}
              Sign Out
            </Button>
          </Spacer>
        </>
      )}
    </>
  );
};

export default LogInButton;
